import ModalStack from '@/components/Custom/ModalStack';

export const unstable_settings = {
  initialRouteName: 'index',
};

export default function PrivateEventEventIdRsvpLayoutRoute() {
  return <ModalStack />;
}
